"use strict";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const {
  typePolicies
} = require('@shared-ui/apollo-type-policies');
module.exports = typePolicies;